import {type TakeFiveChecklistDto, type TakeFiveChecklistData} from '@domain/hroc-checklists'
import {type TFunction} from 'i18next'

import type {TakeFiveChecklistFormValues} from '../types'

import {mapYesNoFormValuesToItem, mapYesNoItemToFormItem} from './yes-no.mappers'

export const mapTakeFiveChecklistDtoToFormValues = (
  {data, kind, preparedBy}: TakeFiveChecklistDto,
  t: TFunction
): TakeFiveChecklistFormValues => {
  const safety = data?.safety
  const hazardAssessment = data?.hazardAssessment

  return {
    kind,
    safety: safety
      ? {
          ...safety,
          peopleInformed: mapYesNoItemToFormItem(safety.peopleInformed),
          rightTools: mapYesNoItemToFormItem(safety.rightTools),
          fitForDuty: mapYesNoItemToFormItem(safety.fitForDuty),
          riskRecognized: mapYesNoItemToFormItem(safety.riskRecognized)
        }
      : null,
    hazardAssessment: hazardAssessment
      ? {
          ...hazardAssessment,
          hazards: hazardAssessment.hazards.map((hazard) => ({
            id: hazard,
            label: t(`takeFive.hazard.${hazard}`)
          })),
          risks: hazardAssessment.risks.map((risk) => ({
            id: risk,
            label: t(`takeFive.risk.${risk}`)
          })),
          preparedBy: preparedBy ? preparedBy.name : null
        }
      : null
  }
}

export const mapTakeFiveChecklistFormValuesToDataDto = ({
  safety,
  hazardAssessment
}: TakeFiveChecklistFormValues): TakeFiveChecklistData => {
  return {
    safety: safety
      ? {
          peopleInformed: mapYesNoFormValuesToItem(safety.peopleInformed),
          rightTools: mapYesNoFormValuesToItem(safety.rightTools),
          fitForDuty: mapYesNoFormValuesToItem(safety.fitForDuty),
          riskRecognized: mapYesNoFormValuesToItem(safety.riskRecognized),
          reasonToWorkSafe: safety.reasonToWorkSafe,
          supervisor: safety.supervisor
        }
      : null,
    hazardAssessment: hazardAssessment
      ? {
          workToBeDone: hazardAssessment.workToBeDone,
          hazards: hazardAssessment.hazards.map((hazard) => hazard.id),
          hazardsComment: hazardAssessment.hazardsComment,
          risks: hazardAssessment.risks.map((risk) => risk.id),
          risksComment: hazardAssessment.risksComment,
          eliminateControlHazard: hazardAssessment.eliminateControlHazard
        }
      : null
  }
}
